import React from 'react';

const BuyButton = ({ label, articleNumber, price, currency, quantityFieldId, href, cssClass, onClick }) => (
    articleNumber ? 
    <button type="button" className={cssClass} onClick={() => onClick(articleNumber, quantityFieldId, price, currency)}>
        {label}
    </button>
    : <a className={cssClass} href={href}>
        {label}
    </a>
)

export default BuyButton;